<template>
  <div>
    <WebHeaderView />
    <div class="register-box">
      <div class="title">创建商家账户</div>
      <van-form :validate-first="true" @submit="onSubmit" :label-width="60">
        <div class="item">
          <van-field
            v-model="frm.username"
            label="用户名"
            placeholder="请填写用户名"
            :rules="[{ required: true, message: '请填写用户名' }]"
            style="border: none"
          />
        </div>
        <div class="item">
          <van-field
            v-model="frm.password"
            type="password"
            label="密码"
            placeholder="请填写密码"
            :rules="[{ required: true, message: '请填写密码' }]"
            style="border: none"
          />
        </div>
        <div class="item">
          <van-field
            v-model="frm.password_confirm"
            type="password"
            label="确认密码"
            placeholder="请填写确认密码"
            :rules="[
              { required: true, message: '请填写确认密码' },
              { validator: validator, message: '两次输入的密码不同' }
            ]"
            style="border: none"
          />
          
        </div>
        <div class="item" v-if="isCode">
          <van-field
            v-model="frm.code"
            label="邀请码"
            placeholder="请填写邀请码"
            :rules="[{ required: true, message: '请填写邀请码' }]"
            style="border: none"
          />
        </div>
        <div style="margin: 36px 0 0">
          <van-button
            block
            native-type="submit"
            :loading="posting"
            loading-text="注册中..."
            style="background-color: #141423; color: #fff; border-radius: 8px"
            >创建账号</van-button
          >
        </div>
      </van-form>
      <div style="font-size: 14px; text-align: right; margin-top: 30px">
        <router-link class="link-btn" :to="'/login'" style="color: #000">
          已有账号，去登录</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import WebHeaderView from '@/components/header/index.vue'
import { setToken, getToken } from '@/utils/cookies'
export default {
  name: 'RegisterView',
  components: { WebHeaderView },
  data () {
    return {
      frm: {
        username: null,
        password: null,
        password_confirm: null,
        code:null
      },
      posting: false,
      isCode: false
    }
  },
  mounted () {
    if (getToken()) {
      this.$router.push({ name: 'mine' })
      return
    }
    this.getsyssetting()
    this.frm.code = this.$route.query.code;
  },
  methods: {
    validator(val){
        return this.frm.password == val
    },
    async getsyssetting(){
            await this.$http({
        method: 'post',
        url: 'syssetting'
      })
        .then(res => {
          this.isCode = res.data.register_invite_status == 1
        })
    },
    async onSubmit () {
      if (this.posting) {
        return
      }
      this.posting = true

      await this.$http({
        method: 'post',
        url: 'register',
        data: this.frm
      })
        .then(res => {
          this.posting = false
          setToken(res.data.token)
          location.reload()
        })
        .catch(() => {
          this.posting = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.register-box {
  margin: 100px 20px;
  background: #fff;
  border-radius: 10px;
  padding: 30px 10px;
  .title {
    width: 100%;
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    line-height: 38px;
    height: 38px;
  }
  .item {
    border: 1px solid #646566;
    margin: 15px 0;
    padding: 3px;
    border-radius: 8px;
  }
}
</style>
